import config from '../config'
import http from '../http'

export default{
	//获取lazada图片
	getLazadaImg:async function(payload) {
		const res = await http({
				url: config.GET_LAZADA_IMG,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//lazada发布产品  发布产品
	textTaa:async function(payload) {
		const res = await http({
				url: 'http://db.auto.sohu.com/api/newSales/brand?brandIds=159&section=2',
				method: 'get',
			})
			return res.data
	},
	//lazada发布产品  发布产品
	publishLazada:async function(payload) {
		const res = await http({
				url: config.PUBLISH_LAZADA_PRODUCT,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//lazada发布产品  获取Lazada类目属性
	getLazadaAttribution:async function(payload) {
			const res = await http({
				url: config.GET_LAZADA_CATEGORY_ATTRIBUTE,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//lazada发布产品  获取Lazada类目
	getLazadaCategory:async function(payload) {
			const res = await http({
				url: config.GET_LAZADA_CATEGORY,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},

	cancelAuditedLazadaOrders:async function(payload) {
			const res = await http({
				url: config.CANCEL_AUDITED_LAZADA_ORDER,
				method: 'post',
				data:payload
			})
			return res.data
	},
	getstoreitembyid:async function(payload) {
			const res = await http({
				url: config.GET_STORE_ITEM_BY_ID,
				method: 'post',
				data:payload
			})
			return res.data
	},

	//仓库获取所有已处理的数据
		getProcessedOrderByStorelazada:async function(payload) {
				const res = await http({
					url: config.GET_STORE_PROCESSED_ORDER_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
	//仓库获取所有物流方式
		getLogisticsBystorelazada:async function(payload) {
				const res = await http({
					url: config.GET_LOGISTICS_STORE_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
		//仓库获取一段时间内打包的订单数量
		getProcessedOrdersByStorelazada:async function(payload) {
				const res = await http({
					url: config.GET_PROCESSED_ORDERS_PARAMS_STORE_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	getStoreOrders:async function(payload) {
				const res = await http({
					url: config.GET_ORDERS_BY_STORE,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
	
	 //卖家获取所有物流方式
		getLogisticsBysellerLazada:async function(payload) {
				const res = await http({
					url: config.GET_LOGISTICS_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
	 //卖家获取一段时间内打包的订单数量
		getProcessedOrdersLazada:async function(payload) {
				const res = await http({
					url: config.GET_PROCESSED_ORDERS_PARAMS_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
		//卖家获取所有已处理的数据
		getProcessedOrderBySellerLazada:async function(payload) {
				const res = await http({
					url: config.GET_SELLER_PROCESSED_ORDER_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
	//高级查询页面-获取lazada所有待处理的订单
	getProcessedOrders:async function(payload) {
		const res = await http({
			url: config.GET_PROCESSED_OREDER_LAZADA,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//高级查询页面-获取lazada所有未审核的订单
	getUnAuditOrders:async function(payload) {
		const res = await http({
			url: config.GET_UNAUDIT_OREDER_LAZADA,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取用户下所有LAZADA订单
	getLazadaOrderByuserid:async function(payload) {
		const res = await http({
			url: config.GET_ALLORDER_BY_USERID,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//在库存允许范围内审核多个订单
	auditLazadaOrdersByStockRule:async function(payload) {
		const res = await http({
			url: config.ZAI_KUCHU_FANWEI_DADANG,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取lazada的物流种类
	getLogistics:async function(payload) {
		const res = await http({
			url: config.GET_TYEP_LOGISTICS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	//生成运单号
	getTrickingNo:async function(payload) {
		const res = await http({
			url: config.GET_TRICKING_NO,
			method: 'post',
			data: payload
		})
		return res.data
	},
	
	//同步lazada订单
	Synchronizeorders:async function(payload) {
		const res = await http({
			url: config.SYN_ORDERS,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//审核全部的订单
	reviewAllorders:async function(payload) {
		const res = await http({
			url: config.REVIEW_ALL_ORDER,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//审核一部分订单
	reviewSomeorders:async function(payload) {
		const res = await http({
			url: config.REVIEW_SOME_ORDER,
			method: 'post',
			data: payload
		})
		return res.data
	},
	
	//取消审核 
	cancelReives:async function(payload) {
		const res = await http({
			url: config.CANCEL_REVIEW,
			method: 'post',
			data:payload
		})
		return res.data
	},
	
	//打印订单
	printOrderlazada:async function(payload) {
		const res = await http({
			url: config.PRINT_ORDER,
			method: 'post',
			data:payload
		})
		return res.data
	},
	//订单号查找
	lookupOrderbyOrder:async function(payload) {
		const res = await http({
			url: config.LOOK_UP_ORDER,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},

}